// src/components/Modal.js
import React from 'react';
import ReactDOM from 'react-dom';
import { XCircle } from 'react-feather';

const Modal = ({ isOpen, onClose, title, children, size = 'md' }) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '2.5xl': 'max-w-[45rem]',
  };

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-overlay backdrop-blur-sm flex items-center justify-center z-50">
      <div
        className={`
          bg-theme-secondary border border-border rounded-xl p-6 w-full
          ${sizeClasses[size] || sizeClasses.md}
          max-h-[90vh] overflow-y-auto
          shadow-theme-xl
        `}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-content-primary">{title}</h2>
          <button
            onClick={onClose}
            className="text-content-muted hover:text-content-primary transition-colors"
          >
            <XCircle size={24} />
          </button>
        </div>
        <div className="text-content-primary">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
